import { render, staticRenderFns } from "./ImportarXmlAditivoConvenio.vue?vue&type=template&id=01643ffa"
import script from "./ImportarXmlAditivoConvenio.vue?vue&type=script&lang=ts"
export * from "./ImportarXmlAditivoConvenio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports